import { React } from "react";
import { Row, Col, Form, Button, Table, InputGroup } from "react-bootstrap";
import { BsPlusCircle, BsTrash } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { encryptId } from "../utils/helpers";

const yesNo = [
    { value: "", label: "Select" },
    { value: "1", label: "Yes" },
    { value: "0", label: "No" },
    { value: "2", label: "Data Not Available" }
];




const Female_Details = ({ form, handleFormChange, rows, setRows, onSubmit, crnDisabled, onDobChange, handleFemaleAgeChange, isSubmitting }) => {

    const activeFlag = encryptId("active");

    const emptyRow = {
        // assay_date: "",
        AMH: "",
        FSH: "",
        LH: "",
        Estradiol: "",
        Progesterone: "",
        TSH: "",
        Prolactin: "",

    };
    const navigate = useNavigate();
    // const [rows, setRows] = useState([{ ...emptyRow }]);

    // const addRow = () => {
    //     setRows([...rows, { ...emptyRow }]);
    // };

    const addRow = () => setRows([...rows, { ...emptyRow }]);


    const deleteRow = (index) => {
        const updated = rows.filter((_, i) => i !== index);
        setRows(updated.length ? updated : [{ ...emptyRow }]);
    };

    const handleRowChange = (index, field, value) => {
        const updated = [...rows];
        updated[index][field] = value;
        setRows(updated);
    };


    return (
        <Form>


            <h5 className="mt-3"><b>Female Partner Data</b></h5>
            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>CRN No</Form.Label>
                    <Form.Control name="CRN_No" value={form.CRN_No} onChange={handleFormChange} disabled={crnDisabled} style={{
                        backgroundColor: crnDisabled ? "#e9ecef" : "#fff"
                    }} />
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Infertility Reg No</Form.Label>
                    <Form.Control name="Infertility_Reg_no" value={form.Infertility_Reg_no} onChange={handleFormChange} />
                </Col>
                <Col md={12} lg={4} xs={12}>
                    <Form.Label>Sample ID</Form.Label>
                    <Form.Control name="sample_id" value={form?.sample_id || ""} onChange={handleFormChange} readOnly
                        style={{ background: "hsla(120, 24%, 89%, 1.00)", fontWeight: "bold" }} />
                </Col>

            </Row>

            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>Patient Name</Form.Label>
                    <Form.Control name="Patient_Name" value={form.Patient_Name} onChange={handleFormChange} />
                </Col>
                <Col md={12} lg={4}>
                    <Form.Label>Date</Form.Label>
                    <Form.Control type="date" name="reg_date" value={form.reg_date} onChange={handleFormChange} />
                </Col>

                <Col md={12} lg={4} xs={12} >
                    <Form.Label>Date of Birth / Age</Form.Label>

                    <InputGroup>
                        {/* DOB */}
                        <Form.Control
                            type="date"
                            value={form?.dob || ""}
                            onChange={(e) => onDobChange(e.target.value)}
                            style={{ fontSize: "13px" }}
                        />

                        {/* Age label */}
                        <InputGroup.Text className="percent-text">Age(Yrs)</InputGroup.Text>

                        {/* Age */}
                        <Form.Control
                            value={form?.Age || ""} onChange={handleFemaleAgeChange}

                            style={{
                                maxWidth: "80px",
                                textAlign: "center",
                                fontSize: "13px"
                            }}
                        />
                    </InputGroup>
                </Col>


            </Row>

            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>Address</Form.Label>
                    <Form.Control name="address" value={form.address} onChange={handleFormChange} />
                </Col>
                <Col md={12} lg={4}>
                    <Form.Label>Occupation (Patient)</Form.Label>
                    <Form.Control name="Occupation" value={form.Occupation} onChange={handleFormChange} />
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Referral By</Form.Label>
                    <Form.Control name="refrred_by" value={form.refrred_by} onChange={handleFormChange} />
                </Col>


            </Row>
            <h5 className="mt-3"><b>History of Drug Allergy</b></h5>

            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>Drug Allergy</Form.Label>
                    <Form.Control name="Drug_Allergy" value={form.Drug_Allergy} onChange={handleFormChange} />
                </Col>
            </Row>

            {/* B. Obstetric History */}
            <h5 className="mt-3"><b>Obstetric History</b></h5>
            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label >Married Since (year)</Form.Label>
                    <Form.Control
                        type="text"
                        name="Married_Since"

                        value={form.Married_Since || ""}
                        onChange={handleFormChange}
                        placeholder="Years"

                    />
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Infertility Duration (Years)</Form.Label>
                    <Form.Control name="Infertility_Duration" value={form.Infertility_Duration} onChange={handleFormChange} />
                </Col>
                <Col md={12} lg={4}>
                    <Form.Label>Type Of Infertility</Form.Label>
                    <Form.Select
                        name="Primary_Infertility"
                        value={form.Primary_Infertility}
                        onChange={handleFormChange}
                    >
                        <option value="">Select</option>
                        <option value="Secondary_Infertility">Secondary Infertility</option>
                        <option value="Primary_Infertility">Primary Infertility</option>

                        <option value="Data_Not_Available">Data Not Available</option>
                    </Form.Select>

                    {/* <Form.Control name="Primary_Infertility" value={form.Primary_Infertility} onChange={handleFormChange} /> */}

                </Col>
            </Row>

            <Row className="mb-3">
                {/* <Col md={12} lg={4}>
                    <Form.Label>Secondary Infertility</Form.Label>

                    <Form.Select
                        name="Secondary_Infertility"
                        value={form.Secondary_Infertility}
                        onChange={handleFormChange}
                    >
                        <option value="">Select</option>
                        <option value="Nulligravida">Nulligravida</option>

                    </Form.Select>

                </Col> */}
                <Col md={12} lg={4}>
                    <Form.Label>Obstetric History</Form.Label>
                    <Form.Control name="Obstetric_History" value={form.Obstetric_History} onChange={handleFormChange} />
                </Col>

                <Col md={8}>
                    <Form.Label>Other Remarks</Form.Label>
                    <Form.Control name="Other_Remarks" value={form.Other_Remarks} onChange={handleFormChange} />
                </Col>
            </Row>

            {/* C. Menstrual History */}
            <h5 className="mt-3"><b> Menstrual History</b></h5>
            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>Age at Menarche</Form.Label>
                    <Form.Control name="Age_at_Menarche" value={form.Age_at_Menarche} onChange={handleFormChange} />
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Day of Current Cycle</Form.Label>
                    <Form.Control name="Day_of_MC" value={form.Day_of_MC} onChange={handleFormChange} />
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Previous Cycle</Form.Label>

                    <Form.Select
                        name="Previous_Cycle"
                        value={form.Previous_Cycle}
                        onChange={handleFormChange}
                    >
                        <option value="">Select</option>
                        <option value="Regular">Regular</option>
                        <option value="Irregular">Irregular</option>
                        <option value="Data_Not_Available">Data Not Available</option>

                    </Form.Select>

                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>Last MC (LMP)</Form.Label>
                    <Form.Control name="Last_MC" value={form.Last_MC} onChange={handleFormChange} />



                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Menstrual Loss</Form.Label>
                    {/* <Form.Control name="Menstrual_Loss" value={form.Menstrual_Loss} onChange={handleFormChange} /> */}

                    <Form.Select
                        name="Menstrual_Loss"
                        value={form.Menstrual_Loss}
                        onChange={handleFormChange}
                    >
                        <option value="">Select</option>
                        <option value="Average">Average</option>
                        <option value="High">High</option>
                        <option value="Low">Low</option>
                        <option value="Data_Not_Available">Data Not Available</option>

                    </Form.Select>
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Dysmenorrhea</Form.Label>
                    <Form.Select name="Dysmenorrhea" value={form.Dysmenorrhea} onChange={handleFormChange}>
                        {yesNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Form.Select>
                </Col>
            </Row>
            <Row className="mb-3">


                <Col md={12} lg={4}>
                    <Form.Label>Postcoital Bleeding</Form.Label>
                    <Form.Select name="Postcoital_Bleeding" value={form.Postcoital_Bleeding} onChange={handleFormChange}>
                        {yesNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Form.Select>
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Intermenstrual Bleeding</Form.Label>
                    <Form.Select name="Intermenstrual_Bleeding" value={form.Intermenstrual_Bleeding} onChange={handleFormChange}>
                        {yesNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Form.Select>
                </Col>
                <Col md={12} lg={4}>
                    <Form.Label>Other Remarks</Form.Label>
                    <Form.Control name="Menstural_Remarks" value={form.Menstural_Remarks} onChange={handleFormChange} />
                </Col>

            </Row>
            <h5 className="mt-4"><b> Sexual History</b></h5>
            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>Intercourse Type</Form.Label>
                    {/* <Form.Control name="Intercourse_type" value={form.Intercourse_type} onChange={handleFormChange} /> */}


                    <Form.Select
                        name="Intercourse_type"
                        value={form.Intercourse_type}
                        onChange={handleFormChange}
                    >
                        <option value="">Select</option>
                        <option value="Unprotected">Unprotected vaginal intercourse</option>
                        <option value="⁠Protected">⁠Protected vaginal intercourse</option>
                        <option value="Irregular">Irregular intercourse</option>
                        <option value="Data_Not_Available">Data Not Available</option>
                    </Form.Select>

                </Col>


                <Col md={12} lg={4}>
                    <Form.Label>Intercourse Frequency</Form.Label>
                    <Form.Control name="Intercourse_Frequency" value={form.Intercourse_Frequency} onChange={handleFormChange} />
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Dyspareunia</Form.Label>
                    <Form.Select name="Dyspareunia" value={form.Dyspareunia} onChange={handleFormChange}>
                        {yesNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Form.Select>
                </Col>
            </Row>

            {/* <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>Erectile Dysfunction</Form.Label>
                    <Form.Select name="Erectile_Dysfunction" value={form.Erectile_Dysfunction} onChange={handleFormChange}>
                        {yesNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Form.Select>
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Premature Ejaculation</Form.Label>
                    <Form.Select name="Premature_Ejaculation" value={form.Premature_Ejaculation} onChange={handleFormChange}>
                        {yesNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Form.Select>
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control name="Sexual_Remarks" value={form.Sexual_Remarks} onChange={handleFormChange} />
                </Col>
            </Row> */}
            <h5 className="mt-4"><b> Other Important History</b></h5>
            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>Hirsutism</Form.Label>
                    <Form.Select name="Hirsutism" value={form.Hirsutism} onChange={handleFormChange}>
                        {yesNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Form.Select>
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Acanthosis Nigricans</Form.Label>
                    <Form.Select name="Acanthosis_Nigricans" value={form.Acanthosis_Nigricans} onChange={handleFormChange}>
                        {yesNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Form.Select>
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Galactorrhoea</Form.Label>
                    <Form.Select name="Galactorrhoea" value={form.Galactorrhoea} onChange={handleFormChange}>
                        {yesNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Form.Select>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>Rubella Vaccination</Form.Label>
                    <Form.Select name="Rubella_Vaccination" value={form.Rubella_Vaccination} onChange={handleFormChange}>
                        {yesNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Form.Select>
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Consanguineous Marriage</Form.Label>
                    <Form.Select name="Consanguineous_Marriage" value={form.Consanguineous_Marriage} onChange={handleFormChange}>
                        {yesNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Form.Select>
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>History Of Contraceptive Method</Form.Label>
                    <Form.Control name="Contraceptive_Method" value={form.Contraceptive_Method} onChange={handleFormChange} />
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={12}>
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control name="History_Remarks" value={form.History_Remarks} onChange={handleFormChange} />
                </Col>
            </Row>

            <h5 className="mt-4"><b> Medical History</b></h5>
            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>Hypertension</Form.Label>
                    <Form.Select name="Hypertension" value={form.Hypertension} onChange={handleFormChange}>
                        {yesNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Form.Select>
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Medication</Form.Label>
                    <Form.Control name="Medication_Hypertension" placeholder="Hypertension Medication" value={form.Medication_Hypertension} onChange={handleFormChange} />
                </Col>


            </Row>

            <Row className="mb-3">

                <Col md={12} lg={4}>
                    <Form.Label>Diabetes</Form.Label>
                    <Form.Select name="Diabetes" value={form.Diabetes} onChange={handleFormChange}>
                        {yesNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Form.Select>
                </Col>
                <Col md={12} lg={4}>
                    <Form.Label>Medication </Form.Label>
                    <Form.Control name="Medication_Diabetes" placeholder="Diabetes Medication" value={form.Medication_Diabetes} onChange={handleFormChange} />
                </Col>


            </Row>
            <Row className="mb-3">


                <Col md={12} lg={4}>
                    <Form.Label>Thyroid</Form.Label>
                    <Form.Select name="Thyroid" value={form.Thyroid} onChange={handleFormChange}>
                        {yesNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Form.Select>
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Medication</Form.Label>
                    <Form.Control name="Medication_Thyroid" placeholder="Thyroid Medication" value={form.Medication_Thyroid} onChange={handleFormChange} />
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>Cardiac</Form.Label>
                    <Form.Select name="Cardiac_Disease" value={form.Cardiac_Disease} onChange={handleFormChange}>
                        {yesNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Form.Select>
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Drugs</Form.Label>
                    <Form.Control name="Drugs_Cardiac_Disease" value={form.Drugs_Cardiac_Disease} placeholder="Drugs Cardiac Disease" onChange={handleFormChange} />
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Medication</Form.Label>
                    <Form.Control name="Medication_Cardiac_Disease" placeholder="Cardiac Medication" value={form.Medication_Cardiac_Disease} onChange={handleFormChange} />
                </Col>
            </Row>

            <Row>
                <Col md={12}>
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control name="Medical_Remarks" value={form.Medical_Remarks} onChange={handleFormChange} />
                </Col>
            </Row>

            <h5 className="mt-4"><b> Surgical History</b></h5>
            <Row className="mb-3">
                <Col md={12}>
                    <Form.Control name="Surgical_History" value={form.Surgical_History} onChange={handleFormChange} />
                </Col>
            </Row>
            <h5 className="mt-4"><b>Family History</b></h5>
            <Row className="mb-3">
                <Col md={12}>
                    <Form.Control name="Family_History" value={form.Family_History} onChange={handleFormChange} />
                </Col>
            </Row>

            <h5 className="mt-4"><b>Treatment History</b></h5>
            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>Ovulation Induction Drugs</Form.Label>
                    <Form.Control type="text" name="Ovulation_Induction_Drugs" value={form.Ovulation_Induction_Drugs} onChange={handleFormChange} />
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label> No. Of Prior IUI</Form.Label>
                    <Form.Control name="IUI" value={form.IUI} onChange={handleFormChange} />
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>No. of Prior IVF</Form.Label>
                    <Form.Control name="Prior_IVF" value={form.Prior_IVF} onChange={handleFormChange} />
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={12}>
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control name="Treatment_Remarks" value={form.Treatment_Remarks} onChange={handleFormChange} />
                </Col>
            </Row>
            <h5 className="mt-4"><b> Examination Findings</b></h5>
            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>Height</Form.Label>
                    <InputGroup>
                        <Form.Control name="Height" value={form.Height} onChange={handleFormChange} />
                        <InputGroup.Text className="percent-text">cm</InputGroup.Text>
                    </InputGroup>

                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Weight</Form.Label>
                    <InputGroup>
                        <Form.Control name="Weight" value={form.Weight} onChange={handleFormChange} />
                        <InputGroup.Text className="percent-text">kg</InputGroup.Text>
                    </InputGroup>                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>BMI</Form.Label>
                    <Form.Control name="BMI" value={form.BMI} onChange={handleFormChange} />
                    {/* <Form.Select
                        name="BMI"
                        value={form.BMI}
                        onChange={handleFormChange}
                    >
                        <option value="">Select</option>
                        <option value="underweight">underweight</option>
                        <option value="normal">normal</option>
                        <option value="overweight">overweight</option>
                        <option value="obesity">obesity</option>
                        <option value="Data_Not_Available">Data Not Available</option>

                    </Form.Select> */}
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>Waist Hip Ratio</Form.Label>
                    <Form.Control name="Waist_Hip_Ratio" value={form.Waist_Hip_Ratio} onChange={handleFormChange} />
                </Col>
                <Col md={12} lg={4}>
                    <Form.Label>Respiratory System Exam</Form.Label>
                    <Form.Control name="Respiratory_System_Examination" value={form.Respiratory_System_Examination} onChange={handleFormChange} />
                </Col>
                <Col md={12} lg={4}>
                    <Form.Label>CVS Examination</Form.Label>
                    <Form.Control name="CVS_Examination" value={form.CVS_Examination} onChange={handleFormChange} />
                </Col>
            </Row>


            <Row className="mb-3">


                <Col md={12} lg={4}>
                    <Form.Label>Breast Examination</Form.Label>
                    <Form.Control name="Breast_Examination" value={form.Breast_Examination} onChange={handleFormChange} />
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Local Examination</Form.Label>
                    <Form.Control name="Local_Examination" value={form.Local_Examination} onChange={handleFormChange} />
                </Col>
                <Col md={12} lg={4}>
                    <Form.Label>Per Abdomen Exam</Form.Label>
                    <Form.Control name="Per_Abdomen_Exam" value={form.Per_Abdomen_Exam} onChange={handleFormChange} />
                </Col>
            </Row>

            <Row className="mb-3">


                <Col md={12} lg={4}>
                    <Form.Label>Per Vaginal Exam</Form.Label>
                    <Form.Control name="Per_Vaginal_Exam" value={form.Per_Vaginal_Exam} onChange={handleFormChange} />
                </Col>
                <Col md={12} lg={4}>
                    <Form.Label>Per Speculum Exam</Form.Label>
                    <Form.Control name="Per_Speculum_Exam" value={form.Per_Speculum_Exam} onChange={handleFormChange} />
                </Col>
            </Row>
            <h5 className="mt-4"><b> Blood Pressure</b></h5>
            <Row className="">
                <Col md={12} lg={4}>
                    {/* <Form.Control name="Blood_Pressure" value={form.Blood_Pressure} onChange={handleFormChange} /> */}
                    <Form.Label>SBP</Form.Label>
                    <InputGroup>
                        <Form.Control
                            type="text"
                            name="Blood_Pressure"
                            value={form.Blood_Pressure || ""}
                            onChange={handleFormChange}
                        />
                        <InputGroup.Text className="percent-text">mm/Hg</InputGroup.Text>
                    </InputGroup>



                </Col>
                <Col md={12} lg={4}>
                    <Form.Label>DBP</Form.Label>
                    <InputGroup>
                        <Form.Control
                            type="text"
                            name="Blood_Pressure_DBP"
                            value={form.Blood_Pressure_DBP || ""}
                            onChange={handleFormChange}
                        />
                        <InputGroup.Text className="percent-text">mm/Hg</InputGroup.Text>
                    </InputGroup></Col>


            </Row>

            <h5 className="mt-4"><b>Investigation</b></h5>

            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>Blood Group</Form.Label>
                    {/* <Form.Control name="Blood_Group" value={form.Blood_Group} onChange={handleFormChange} /> */}
                    <Form.Select
                        name="Blood_Group"
                        value={form.Blood_Group || ""}
                        onChange={handleFormChange}

                    >
                        <option value="" disabled>
                            Select blood group
                        </option>

                        {/* Modern concise labels */}
                        <option value="A+">A+</option>
                        <option value="A-">A−</option>

                        <option value="B+">B+</option>
                        <option value="B-">B−</option>

                        <option value="AB+">AB+</option>
                        <option value="AB-">AB−</option>

                        <option value="O+">O+</option>
                        <option value="O-">O−</option>

                        <option value="NA">Not available</option>
                    </Form.Select>
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>CBC</Form.Label>
                    <Form.Control name="CBC" value={form.CBC} onChange={handleFormChange} />
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Blood Sugar</Form.Label>
                    <Form.Control name=" Blood_Sugar_R" value={form.Blood_Sugar_R} onChange={handleFormChange} />
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>HbA1C</Form.Label>
                    <Form.Control name="HbA1C" value={form.HbA1C} onChange={handleFormChange} />
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Hb Electrophoresis</Form.Label>
                    <Form.Control name="Hb_Electrophoresis" value={form.Hb_Electrophoresis} onChange={handleFormChange} />
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>TORCH</Form.Label>
                    <Form.Control name="TORCH" value={form.TORCH} onChange={handleFormChange} />
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>Thrombophilia Profile</Form.Label>
                    <Form.Control name="Thrombophilia_Profile" value={form.Thrombophilia_Profile} onChange={handleFormChange} />
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Cervical Smear</Form.Label>
                    <Form.Control name="Cervical_Smear" value={form.Cervical_Smear} onChange={handleFormChange} />
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Karyotyping(POCs)</Form.Label>
                    <Form.Control name="Karyotyping" value={form.Karyotyping} onChange={handleFormChange} />
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>Karyotyping Wife</Form.Label>
                    <Form.Control name="Karyotyping_Wife" value={form.Karyotyping_Wife} onChange={handleFormChange} />
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>HIV</Form.Label>
                    <Form.Select name="HIV" value={form.HIV} onChange={handleFormChange}>
                        {yesNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Form.Select>
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>HCV</Form.Label>
                    <Form.Select name="HCV" value={form.HCV} onChange={handleFormChange}>
                        {yesNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Form.Select>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>HBsAg</Form.Label>
                    <Form.Select name="HBsAg" value={form.HBsAg} onChange={handleFormChange}>
                        {yesNo.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Form.Select>
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>HSG</Form.Label>
                    <Form.Control name="HSG" value={form.HSG} onChange={handleFormChange} />
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>VDRL</Form.Label>
                    <Form.Control name="VDRL_Aldo" value={form.VDRL_Aldo} onChange={handleFormChange} />
                </Col>
                <Row className="mb-3">
                    <Col md={12}>
                        <Form.Label>Remark</Form.Label>
                        <Form.Control name="investigation_remark" as="textarea" rows={1} value={form.investigation_remark} onChange={handleFormChange} />
                    </Col>
                </Row>
                {/* <Col md={12} lg={4}>
                    <Form.Label>Hystero Laproscopy</Form.Label>
                    <Form.Control name="Hystero_laproscopy" value={form.Hystero_laproscopy} onChange={handleFormChange} />
                </Col> */}
            </Row>

            <h5 className="mt-4"><b>Hormonal Assay</b></h5>

            <Table bordered responsive>
                <thead style={{ background: "#1a3d7c", color: "#fff" }}>
                    <tr>

                        <th>Sr</th>
                        <th>AMH</th>
                        <th>FSH</th>
                        <th>LH</th>
                        <th>Estradiol</th>
                        <th>Progesterone</th>
                        <th>TSH</th>
                        <th>Prolactin</th>
                        <th className="text-center">
                            <Button variant="success" size="sm" onClick={addRow}>
                                <BsPlusCircle />
                            </Button>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {rows.map((row, i) => (
                        <tr key={i}>
                            <td>{i + 1}</td>

                            {/* <td>
                                <Form.Control
                                    type="date"
                                    value={row.assay_date}
                                    onChange={(e) => handleRowChange(i, "assay_date", e.target.value)}
                                />
                            </td> */}

                            {[
                                "AMH",
                                "FSH",
                                "LH",
                                "Estradiol",
                                "Progesterone",

                                "TSH",
                                "Prolactin"

                            ].map((field) => (
                                <td key={field}>
                                    <Form.Control
                                        type="text"

                                        value={row[field]}
                                        onChange={(e) => handleRowChange(i, field, e.target.value)}
                                    />
                                </td>
                            ))}



                            <td className="text-center">
                                <Button
                                    variant="danger"
                                    size="sm"
                                    onClick={() => deleteRow(i)}
                                    disabled={rows.length === 1}
                                >
                                    <BsTrash />
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <h5 className="mt-4"><b>Other Investigative Findings</b></h5>
            <Row className="mb-3">
                <Col md={12} lg={4}>
                    <Form.Label>Mid-cycle Endometrial Thickness</Form.Label>
                    <InputGroup> <Form.Control name="Mid_cycle_Endometrial_Thickness" value={form.Mid_cycle_Endometrial_Thickness} onChange={handleFormChange} />
                        <InputGroup.Text className="percent-text">mm</InputGroup.Text>
                    </InputGroup>
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Ultrasound Findings</Form.Label>
                    <Form.Control name="Ultrasound_Findings" value={form.Ultrasound_Findings} onChange={handleFormChange} />
                </Col>

                <Col md={12} lg={4}>
                    <Form.Label>Hystero-laparoscopy Findings</Form.Label>
                    <Form.Control name="Hystero_laparoscopy_Findings" value={form.Hystero_laparoscopy_Findings} onChange={handleFormChange} />
                </Col>

                <Col md={12}>
                    <Form.Label>Any Other Investigations Remark</Form.Label>
                    <Form.Control name="female_Remark" value={form.female_Remark} onChange={handleFormChange} />
                </Col>
            </Row>


            <Row className="justify-content-center mt-4">
                <Col xs="auto">
                    {/* <Button
                        variant="primary"
                        className="px-4 me-3"
                        onClick={onSubmit}
                    >
                        Submit
                    </Button> */}

                    <button
                        type="button"
                        onClick={onSubmit}   // or any function you already use
                        className="floating-btn px-4 me-3" disabled={isSubmitting}
                    >
                        {isSubmitting ? "Submitting..." : "Save"}                    </button>

                    <Button
                        variant="outline-secondary"
                        className="px-4"
                        onClick={() =>
                            navigate(`/Patient_report_sample_id_wise/${encodeURIComponent(activeFlag)}`)
                        }
                    >
                        Exit
                    </Button>
                </Col>
            </Row>

        </Form>
    );
};

export default Female_Details;
